<template>
  <vs-popup
    button-close-hidden
    class="popup"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <img
      class="vs-popup--img"
      :src="require('@/assets/shipo-popup-icon-terminate.svg')"
    >
    <h3 class="vs-popup--content-title">
      Leave This Page
    </h3>
    <p class="vs-popup--content-subtitle">
      All changes data will be lost
    </p>
    <div class="mt-5 w-full flex flex-row justify-center items-center">
      <vs-button
        type="filled"
        color="secondary"
        class="w-32 mr-2 font-semibold"
        @click="$emit('cancel')"
      >
        Stay Page
      </vs-button>
      <vs-button
        type="border"
        color="secondary"
        class="w-32 ml-2 font-semibold"
        @click="$emit('close')"
      >
        Leave Page
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'ConfirmationPopUp'
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-12;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }

      &-subtitle {
        @apply text-grey-001;
        @apply mt-2 mb-5;
      }
    }

    &--img {
      width: 152px;
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
